import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconDocumentStack12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconDocumentStack12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M9.5 9H9V5.928a2 2 0 0 0-.614-1.441l-.174-.168H10V8.5a.5.5 0 0 1-.5.5M7.014 3.167V1H4.5a.5.5 0 0 0-.5.5V2h.994a2 2 0 0 1 1.387.558zM3 2v-.5A1.5 1.5 0 0 1 4.5 0h2.494a2 2 0 0 1 1.387.558l2.005 1.929A2 2 0 0 1 11 3.928V8.5A1.5 1.5 0 0 1 9.5 10H9v.5A1.5 1.5 0 0 1 7.5 12h-5A1.5 1.5 0 0 1 1 10.5v-7A1.5 1.5 0 0 1 2.5 2zm0 1h-.5a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5V6.32H5.014V3zm6.793.32a1 1 0 0 0-.1-.112l-1.68-1.615v1.726zm-2.1 1.888a1 1 0 0 1 .1.111h-1.78V3.593z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconDocumentStack12);
